import { WSTable, WSTableCell } from "@wingspanhq/fe-component-library";
import { PaymentRequirementStrategy } from "@wingspanhq/payments/dist/interfaces";
import { getPayeeNames } from "../../modules/Payees/selectors/getPayeeNames";
import { useQueryPayeeRows } from "../../query/search/payee/queries/useQueryPayeeRows";
import {
  pillAutopayOff,
  pillAutopayOn,
  useModalAutopaySettings
} from "./ModalAutopaySettings";

export const TablePayees: React.FC = () => {
  const queryPayeeRows = useQueryPayeeRows();

  const modalAutopaySettings = useModalAutopaySettings();

  return (
    <WSTable
      tableData={(queryPayeeRows.data || []).map(payeeRow => {
        const names = getPayeeNames(payeeRow);

        return {
          id: payeeRow.payeeId,
          data: {
            avatarText: names.getResolvedName(true) || "--",
            primaryName: names.getResolvedName(true),
            secondaryName: names.getResolvedSecondaryName(),
            autopay:
              payeeRow.payerOwnedData.autoPayStrategy ===
              PaymentRequirementStrategy.All
          }
        };
      })}
      columns={[
        {
          config: {
            header: {
              text: "Name"
            }
          },
          renderFunction: row => (
            <WSTableCell
              avatar={{
                type: "text",
                text: row.data.avatarText
              }}
              text={row.data.primaryName}
              secondaryText={row.data.secondaryName}
            />
          )
        },
        {
          config: {
            header: {
              text: "Autopay"
            }
          },
          renderFunction: row => (
            <WSTableCell
              pill={row.data.autopay ? pillAutopayOn : pillAutopayOff}
            />
          )
        }
      ]}
      rowMenuActions={row => [
        {
          icon: "settings",
          label: "Autopay settings",
          onClick: () => {
            modalAutopaySettings.open({
              payeeId: row.id
            });
          }
        }
      ]}
    />
  );
};
